import { useState } from 'react';

function EyeIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M2.4 12S6.2 6.4 12 6.4 21.6 12 21.6 12 17.8 17.6 12 17.6 2.4 12 2.4 12Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="2.7" fill="none" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

function EyeOffIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M3.2 4.2 20.8 19.8"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M9.6 6.6A10 10 0 0 1 12 6.4c5.8 0 9.6 5.6 9.6 5.6a16.5 16.5 0 0 1-3.3 3.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.3 8.2A16.8 16.8 0 0 0 2.4 12S6.2 17.6 12 17.6c1.2 0 2.3-.2 3.3-.6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.9 10.1a2.7 2.7 0 0 0 3.8 3.7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function PasswordField({
  label,
  value,
  onChange,
  autoComplete,
  required = false,
  minLength,
  placeholder,
  className = '',
  name,
}) {
  const [visible, setVisible] = useState(false);
  const action = visible ? 'Hide' : 'Show';
  const filled = Boolean(String(value || '').trim());

  return (
    <label className={`field${className ? ` ${className}` : ''}`}>
      <span>{label}</span>
      <div className="password-field">
        <input
          type={visible ? 'text' : 'password'}
          name={name}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          required={required}
          minLength={minLength}
          placeholder={placeholder}
          className={filled ? 'settings-field-filled' : undefined}
        />
        <button
          type="button"
          className="password-toggle"
          aria-label={`${action} ${label.toLowerCase()}`}
          aria-pressed={visible}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => setVisible((current) => !current)}
        >
          {visible ? <EyeOffIcon /> : <EyeIcon />}
        </button>
      </div>
    </label>
  );
}
